import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpDeleteProjectBudget, HttpDeleteProjectBudgetOptions} from '../http/budget.http'
import {ProjectBudgets} from '../types'

export const useDeleteProjectBudget = (
    options?: UseMutationOptions<unknown, unknown, HttpDeleteProjectBudgetOptions>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: httpDeleteProjectBudget,
        ...options,
        onSuccess: (data, variables, context) => {
            queryClient.setQueryData([QUERY_KEYS.PROJECT_BUDGETS], (oldData: ProjectBudgets[]) =>
                oldData.filter(item => item.id !== variables.urlParams.id)
            )
            options?.onSuccess?.(data, variables, context)
        }
    })
}
